import routerGuards from '@/router/guards';

export default {
	// Before new Vue is called: good place to define some routes or vuex modules
	beforeCreate({ store, router }) {
		routerGuards({ store, router });
	},
};
